const getVariantFacetName = (variant, productType) => {
  if (productType === "Frames" || productType === "Sunglasses") {
    const frameColor = variant.frame?.color.localized;
    const lensColor = variant.lensColor;
    return !lensColor ? frameColor : `${lensColor} / ${frameColor}`;
  }
  if (productType === "Accessories") {
    return variant.accessoryColor?.localized;
  }
  if (productType === "Solutions") {
    const volume = variant.packageOption;
    return `${volume}`;
  }
};
export {
  getVariantFacetName
};
//# sourceMappingURL=utils.js.map
